import React from 'react';
import { Link } from 'react-router-dom';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '../ui/popover';
import { itemIsVisible } from './sidebarTree';

/*
 * The collapsed rail's way into a grouped menu.
 *
 * Without this, a collapsed group icon was a no-op: its click handler was gated
 * on the rail already being expanded. With a mouse that is mostly invisible,
 * because hovering to reach the icon expands the rail anyway — but a touch
 * device never sets hover, so on a tablet none of the grouped menus could be
 * opened at all.
 *
 * Built on the Radix popover already in the kit, so dismissal, Escape, focus
 * return and outside-click all come for free rather than being re-implemented.
 */
const SidebarFlyout = ({
  menu,
  isOpen,
  onOpenChange,
  hasAction,
  isSuperAdmin,
  activePath,
  onNavigate,
  children,
}) => {
  const entries = [];
  menu.items.forEach((item) => {
    if (item.children) {
      item.children.forEach((child) => {
        if (itemIsVisible({ item: child, menu, hasAction, isSuperAdmin })) {
          entries.push(child);
        }
      });
    } else if (itemIsVisible({ item, menu, hasAction, isSuperAdmin })) {
      entries.push(item);
    }
  });

  return (
    <Popover open={isOpen} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent
        side="right"
        align="start"
        sideOffset={8}
        className="w-56 p-1.5"
      >
        <p className="px-2 py-1.5 m-0 text-[10px] font-bold uppercase tracking-[0.08em] text-nysmah-muted">
          {menu.title}
        </p>
        <ul className="m-0 p-0 list-none flex flex-col">
          {entries.map((entry) => (
            <li key={entry.path}>
              <Link
                to={entry.path}
                onClick={onNavigate}
                aria-current={entry.path === activePath ? 'page' : undefined}
                className={`block px-2 py-1.5 rounded-md text-[12.5px] no-underline transition-colors ${
                  entry.path === activePath
                    ? 'bg-[#EFF4F6] text-nysmah-dark font-semibold'
                    : 'text-[#3E4C54] hover:bg-[#F0F4F5] hover:text-nysmah-dark'
                }`}
              >
                {entry.label}
              </Link>
            </li>
          ))}
        </ul>
      </PopoverContent>
    </Popover>
  );
};

export default SidebarFlyout;
